/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/lock-2-opened";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Lock2Opened";
export { I as Lock2Opened };
